import React from 'react';
import styled from 'styled-components/macro';
import { Typography } from '@deeptrue-frontend/ui';
import { ReactComponent as Check } from 'assets/icons/Check2.svg';

const SidebarPlan = styled.div`
  background: #ffffff;
  border: 1px solid #e6e6e5;
  border-radius: 0.375rem;
  padding: 2rem;
`;

const Price = styled(Typography)`
  color: ##253858;
  font-size: 1.25rem;
  margin-top: 0.5rem;
  font-weight: 500;
`;

const SidebarFeaturesList = styled.ul`
  padding: 0 1rem;
  list-style: none;
`;

const SidebarFeature = styled.li`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
`;

const Divider = styled.div`
  border-bottom: 1px solid #e6e6e5;
  margin: 1.5rem 0;
`;

const DiscountPrice = styled(Typography)`
  font-size: 0.875rem;
  color: #5c6370;
  text-decoration: line-through;
`;

type PlanProps = {
  name: string;
  fee: number | string;
  features: string[];
  featuresTitle?: string;
  footerNote?: string;
  discountFee: string | null;
};

const Plan = ({
  name,
  fee,
  discountFee,
  featuresTitle,
  footerNote,
  features,
}: PlanProps) => {
  return (
    <SidebarPlan>
      <Typography mb="0.5rem" weight="medium" variant="copy1">
        {name}
      </Typography>
      {discountFee ? (
        <>
          <DiscountPrice>{fee}</DiscountPrice>
          <Price>{discountFee}</Price>
        </>
      ) : (
        <Price>{fee}</Price>
      )}

      <Divider />
      <Typography mt="0.5rem" mb="0.5rem" weight="medium" variant="copy2">
        {featuresTitle}:
      </Typography>
      <SidebarFeaturesList>
        {features.map((feature: string, idx: number) => (
          <SidebarFeature key={`plan-feature-${idx}`}>
            <Check />
            <Typography variant="copy2" ml={'0.4rem'}>
              {feature}
            </Typography>
          </SidebarFeature>
        ))}
      </SidebarFeaturesList>

      {footerNote && <Typography variant="copy2">* {footerNote}</Typography>}
    </SidebarPlan>
  );
};

export default Plan;
